import { createSlice } from "@reduxjs/toolkit";

export const requestproductSlice = createSlice({
  name: "requestproduct",
  initialState: {
    value: "",
    list: [],
  },
  reducers: {
    clear: (state) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.value = "";
    },
    set: (state, action) => {
      state.value = action.payload;
    },
    pushList: (state, action) => {
      if (state.list.filter((prd) => prd.id === action.payload.id).length === 0)
        state.list = [...state.list, action.payload];
    },
    updateList: (state,action) =>{
      let index = state.list.findIndex((prd) => prd.id === action.payload.id);
      console.log(index);
       state.list = [...state.list.slice(0,index),action.payload,...state.list.slice(index+1)];
    },
    removefromlist: (state, action) => {
      //console.log(action.payload);
      state.list = [...action.payload];
    },
  },
});

export const {
  clear,
  pushList,
  removefromlist,
  updateList,
  set,
} = requestproductSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const selectRequestproduct = (state) => state.requestproduct.value;
export const getListofRequestproduct = (state) => state.requestproduct.list;
export default requestproductSlice.reducer;
